export default __webpack_public_path__ + "static/SR China - ISO 9001 - Certificate-bf3ebd70251c31b332a2d9b3b8b2eebf.pdf";